import { render } from "./Outro.vue?vue&type=template&id=ee67e494"
import script from "./Outro.vue?vue&type=script&lang=js"
export * from "./Outro.vue?vue&type=script&lang=js"

import "./Outro.vue?vue&type=style&index=0&id=ee67e494&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__